<p-select [options]="items" [(ngModel)]="selectedItems"
          [multiple]="true" optionLabel="name" dataKey="organizationId"
          (onChange)="onSelectionChange()"
          appendTo="body" class="w-full">
  <ng-template #selectedItem>
    <span>{{ getLabel() }}</span>
  </ng-template>
  <ng-template let-item #item>
    <div class="flex items-center gap-2">
      <p-checkbox [ngModel]="isItemSelected(item)" [binary]="true" [tabindex]="-1" [readonly]="true" />
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
</p-select>
